import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Member } from 'src/app/models/member.model';
import { Deputies } from 'src/app/models/deputy.model';
import { IPosition } from 'src/app/interfaces/IPosition';
import { MemberService } from 'src/app/services/member.service';
import { DeputyService } from 'src/app/services/deputy.service';
import { COUNTRY_TYPES, POSITION_TYPES, GP_TYPES, COMMISSIONS, POSITION_TYPES_B } from 'src/app/enums/enums';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { IGroups } from 'src/app/interfaces/iGroups';
import { Search } from 'src/app/models/search.model';
declare var $: any;

@Component({
  selector: 'app-diputados',
  templateUrl: './diputados.component.html',
  styleUrls: ['./diputados.component.css'],
  providers: [MemberService, UserService, DeputyService]
})
export class DiputadosComponent implements OnInit {
  public deputies: Deputies[];
  public identity: string;
  public token: string;
  public status: string;
  public deputy: Deputies;
  public nombreBuscar: Search;
  public one: number = 1;
  public two: number = 2;
  public three: number = 3;
  public four: number = 4;
  public five: number = 5;
  public six: number = 6;
  public seven: number = 7;
  public eight: number = 8;
  public nine: number = 9;
  public then: number = 10;
  public page: number = 1;
  public pageSize: number = 10;
  public loading: boolean = false;
  public isSubmitting: boolean = false;
  public isDeleting: boolean = false;
  public isUpdating: boolean = false;
  activePosition: boolean;
  segundoGrupo: boolean;
  tercerGrupo: boolean;
  primerGrupo: boolean;
  muestraPar: boolean;
  valoreuro: string;
  valorex: string;
  groups: IGroups;
  position: IPosition;
  nose: Array<IGroups>[];
  nosedos: IGroups[];
  undi = undefined;
  comisiones = Object.values(COMMISSIONS);
  grupos = Object.values(GP_TYPES);
  cargos = Object.values(POSITION_TYPES);
  cargosj = Object.values(POSITION_TYPES_B);
  paises = Object.values(COUNTRY_TYPES);
  exLeaderInput: boolean = true;
  blockInput: boolean = true;
  boardInput: boolean = true;
  partidoInput: boolean = true;
  commissionInput: boolean = true;
  parlaInput: boolean = true;

  constructor(
    private _membersService: MemberService,
    private _deputyService: DeputyService,
    private _userService: UserService,
    private _router: Router,
    protected _sanitizer: DomSanitizer,
  ) {
    this.clearDeputy();
    this.clearSearch();
  }

  ngOnInit(): void {
    $('html,body').scrollTop(0);
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    if (!this.identity || !this.token)
      this._router.navigate(['/iniciar-sesion']);
    else
      this.listarDiputados();
  }

  listarDiputados(): void {
    this.clearSearch();
    this.loading = true;
    this._deputyService.listDiputys().subscribe(

      res => {
        if (res.deputies?.length <= 0) {
          this.status = 'error';
        } else {
          if (res.deputies?.length === 0) {
            alert('No hay diputados para mostrar');
          } else {
            this.deputies = res.deputies;
            /* console.log(this.deputies); */
            this.sortArray(this.deputies);
            this.nosedos = this.deputy.parliamentaryGroups;
            /* console.log(this.deputies) */
          }
          this.status = 'ok';
        }
      },
      err => this.onError(err)
    );

  }

  onError(error: any): void {
    let errorMessage = error;
    alert("Error al ejecutar la acción");
    if (errorMessage != null) {
      this.status = 'error';
    }
    this.isSubmitting = false;
    this.isDeleting = false;
    this.isUpdating = false;
  }

  clearDeputy() {
    this.deputy = new Deputies('', '', '', '', this.clearIPosition(), '', this.clearIGroup(), [this.clearIGroup()], this.clearIPosition(), false, '', '', false, '', '', '', true);

  }

  clearSearch() {
    this.nombreBuscar = new Search('');
  }

  clearIGroup(): IGroups {
    return {
      name: '',
      position: ''
    }
  }

  setDeputy(deputies: Deputies): void {
    this.deputy = deputies;
    if (this.deputy.exLeader == false) {
      this.exLeaderInput = false;
    }
    if (this.deputy.womensBlock.position == undefined) {
      this.blockInput = false;
    }
    if (this.deputy.boardOfDirectors.position == undefined) {
      this.boardInput = false;
    }
    if (this.deputy.politicalParty == undefined) {
      this.partidoInput = false;
    }
    if (this.deputy.commission.name == undefined) {
      this.commissionInput = false;
    }
    if (this.deputy.parliamentaryGroups.length == 0) {
      this.parlaInput = false;
      this.muestraPar = false;
    }
    /* if (this.deputy.parliamentaryGroups == []) {

    } */
  }

  clearIPosition(): IPosition {
    return {
      position: ''
    }
  }

  addDeputy(): void {
    if (this.deputy.womensBlock.position === "") {
      this.deputy.womensBlock = {};
    }
    if (this.deputy.boardOfDirectors.position === "") {
      this.deputy.boardOfDirectors = {};
    }
    if (this.deputy.commission.name === "") {
      this.deputy.commission = {};
    }
    if (this.deputy.commission.position === "Presidente" || this.deputy.commission.position === "Presidenta") {
      this.deputy.commissionOrder = "1";
    }
    if (this.deputy.commission.position === "Vice-Presidente" || this.deputy.commission.position === "Vice-Presidentea") {
      this.deputy.commissionOrder = "2";
    }
    if (this.deputy.commission.position === "Secretario" || this.deputy.commission.position === "Secretaria") {
      this.deputy.commissionOrder = "3";
    }
    if (this.deputy.commission.position === "Tesorero" || this.deputy.commission.position === "Tesorera") {
      this.deputy.commissionOrder = "4";
    }
    if (this.deputy.commission.position === "Vocal") {
      this.deputy.commissionOrder = "5";
    }
    if (this.deputy.commission.position === "Integrante") {
      this.deputy.commissionOrder = "6";
    }
    if (this.deputy.womensBlock.position === "Presidente" || this.deputy.womensBlock.position === "Presidenta") {
      this.deputy.blockOrder = "1";
    }
    if (this.deputy.womensBlock.position === "Vice-Presidente" || this.deputy.womensBlock.position === "Vice-Presidentea") {
      this.deputy.blockOrder = "2";
    }
    if (this.deputy.womensBlock.position === "Secretario" || this.deputy.womensBlock.position === "Secretaria") {
      this.deputy.blockOrder = "3";
    }
    if (this.deputy.womensBlock.position === "Tesorero" || this.deputy.womensBlock.position === "Tesorera") {
      this.deputy.blockOrder = "4";
    }
    if (this.deputy.womensBlock.position === "Vocal") {
      this.deputy.blockOrder = "5";
    }
    if (this.deputy.womensBlock.position === "Integrante") {
      this.deputy.blockOrder = "6";
    }
    if (this.deputy.parliamentaryGroups[0].position === "Presidente" || this.deputy.parliamentaryGroups[0].position === "Presidenta") {
      this.deputy.groupOrder = "1";
    }
    if (this.deputy.parliamentaryGroups[0].position === "Vice-Presidente" || this.deputy.parliamentaryGroups[0].position === "Vice-Presidentea") {
      this.deputy.groupOrder = "2";
    }
    if (this.deputy.parliamentaryGroups[0].position === "Secretario" || this.deputy.parliamentaryGroups[0].position === "Secretaria") {
      this.deputy.groupOrder = "3";
    }
    if (this.deputy.parliamentaryGroups[0].position === "Tesorero" || this.deputy.parliamentaryGroups[0].position === "Tesorera") {
      this.deputy.groupOrder = "4";
    }
    if (this.deputy.parliamentaryGroups[0].position === "Vocal") {
      this.deputy.groupOrder = "5";
    }
    if (this.deputy.parliamentaryGroups[0].position === "Integrante") {
      this.deputy.groupOrder = "6";
    }
    if (this.deputy.parliamentaryGroups[0].name === "") {
      this.deputy.parliamentaryGroups[0].name = "Ninguno";
      this.deputy.parliamentaryGroups[0].position = "No Pertenece";
    }
    /* if (this.deputy.parliamentaryGroups[0].name === "") {
      this.deputy.parliamentaryGroups = [];
      this.deputy.parliamentaryGroups.splice(1, 1);
      this.primerGrupo = false;
    }
    if (this.deputy.parliamentaryGroups.length > 1) {
      this.deputy.parliamentaryGroups = [];
      this.deputy.parliamentaryGroups.splice(2, 1);
      this.segundoGrupo = false;
    }
    if (this.deputy.parliamentaryGroups.length > 2) {
      this.deputy.parliamentaryGroups = [];
      this.deputy.parliamentaryGroups.splice(3, 1);
      this.tercerGrupo = false;
    } */
    if (this.valorex === "pertenece") {
      this.deputy.exLeader = true;
    } else {
      this.deputy.exLeader = false;
    }
    if (this.valoreuro === "pertenece") {
      this.deputy.eurolat = true;
    } else {
      this.deputy.eurolat = false;
    }
    /*  if (this.deputy.parliamentaryGroups[2] === undefined) {
       this.deputy.parliamentaryGroups[2].name = "";
       this.deputy.parliamentaryGroups[2].position = "";
     } */
    this._deputyService.addDeputy(this.deputy).subscribe(
      response => {
        if (response.deputy) {
          this.status = 'ok';
          this.clearDeputy();
          confirm("Registro agregado exitosamente");
          /* window.location.reload(); */
        }
      },
      error => {
        console.log(this.deputy)
        var errorMessage = error;
        if (errorMessage != null) {
          this.status = 'error'
        }
      }
    );
    this.listarDiputados();
  }

  hacertruePosition(val: string) {
    if (val === "pertenece") {
      this.activePosition = true;
    } else if (val === "noPertenece") {
      this.activePosition = false;
    }
    console.log("me dio click");
  }

  hacertrue(): void {

    if ((!this.tercerGrupo) && (!this.segundoGrupo) && (!this.primerGrupo)) {
      this.primerGrupo = true;
      this.deputy.parliamentaryGroups[0] = { name: "", position: "" };
    } else if ((!this.segundoGrupo) && (!this.tercerGrupo) && (this.primerGrupo)) {
      this.segundoGrupo = true;
      this.deputy.parliamentaryGroups[1] = { name: "", position: "" };
    } else if ((this.segundoGrupo) && (!this.tercerGrupo) && (this.primerGrupo)) {
      this.tercerGrupo = true;
      this.deputy.parliamentaryGroups[2] = { name: "", position: "" };
    }

    /*  if (this.primerGrupo) {
       this.segundoGrupo = true;
     }
     if (this.segundoGrupo) {
       this.tercerGrupo = true;
     }
     this.primerGrupo = true; */
  }

  hacerfalse(): void {
    /*  let foo = this.hola;
     this.hola = foo === false ? true : false; */
    /* if ((this.tercerGrupo) && (this.segundoGrupo) && (this.primerGrupo)) {
      this.tercerGrupo = false;
      this.deputy.parliamentaryGroups.splice(3, 1);
      this.segundoGrupo = false;
    } else if (this.primerGrupo) {
      this.primerGrupo = false;
    } */

    if ((this.tercerGrupo) && (this.segundoGrupo) && (this.primerGrupo)) {
      this.tercerGrupo = false;
    } else if ((this.segundoGrupo) && (!this.tercerGrupo) && (this.primerGrupo)) {
      this.segundoGrupo = false;
    } else if ((!this.segundoGrupo) && (!this.tercerGrupo) && (this.primerGrupo)) {
      this.primerGrupo = false;
    }

    /* this.primerGrupo = false;
    this.segundoGrupo = false;
    this.tercerGrupo = false;
    this.deputy.parliamentaryGroups[0] = {};
    this.deputy.parliamentaryGroups[1] = {};
    this.deputy.parliamentaryGroups[2] = {};
    console.log(this.deputy.parliamentaryGroups[3]); */
    /* if ((this.hola) && (this.holados)) {
     this.holados = false;
   } else if ((this.hola) && (!this.holados)) {
     this.hola = false;
   } */
  }

  deleteEvent() {
    if (confirm("¿esta seguro de que quiere eliminar?")) {
      this._deputyService.deleteDeputy(this.deputy.id).subscribe(
        response => {
          this.listarDiputados();
          this.status = "ok"
          window.location.reload();
        }, error => {
          var errorMessage = <any>error
          if (errorMessage != null) {
            this.status = 'error'
          }
        }
      )
    }
    this.listarDiputados();
  }

  actulizarDiputado() {
    if (this.valoreuro === "pertenece") {
      this.deputy.eurolat = true;
    } else {
      this.deputy.eurolat = false;
    }
    if (this.deputy.commission.position === "Presidente" || this.deputy.commission.position === "Presidenta") {
      this.deputy.commissionOrder = "1";
    }
    if (this.deputy.commission.position === "Vice-Presidente" || this.deputy.commission.position === "Vice-Presidentea") {
      this.deputy.commissionOrder = "2";
    }
    if (this.deputy.commission.position === "Secretario" || this.deputy.commission.position === "Secretaria") {
      this.deputy.commissionOrder = "3";
    }
    if (this.deputy.commission.position === "Tesorero" || this.deputy.commission.position === "Tesorera") {
      this.deputy.commissionOrder = "4";
    }
    if (this.deputy.commission.position === "Vocal") {
      this.deputy.commissionOrder = "5";
    }
    if (this.deputy.commission.position === "Integrante") {
      this.deputy.commissionOrder = "6";
    }
    if (this.deputy.womensBlock.position === "Presidente" || this.deputy.womensBlock.position === "Presidenta") {
      this.deputy.blockOrder = "1";
    }
    if (this.deputy.womensBlock.position === "Vice-Presidente" || this.deputy.womensBlock.position === "Vice-Presidentea") {
      this.deputy.blockOrder = "2";
    }
    if (this.deputy.womensBlock.position === "Secretario" || this.deputy.womensBlock.position === "Secretaria") {
      this.deputy.blockOrder = "3";
    }
    if (this.deputy.womensBlock.position === "Tesorero" || this.deputy.womensBlock.position === "Tesorera") {
      this.deputy.blockOrder = "4";
    }
    if (this.deputy.womensBlock.position === "Vocal") {
      this.deputy.blockOrder = "5";
    }
    if (this.deputy.womensBlock.position === "Integrante") {
      this.deputy.blockOrder = "6";
    }
    if (this.deputy.parliamentaryGroups[0].position === "Presidente" || this.deputy.parliamentaryGroups[0].position === "Presidenta") {
      this.deputy.groupOrder = "1";
    }
    if (this.deputy.parliamentaryGroups[0].position === "Vice-Presidente" || this.deputy.parliamentaryGroups[0].position === "Vice-Presidentea") {
      this.deputy.groupOrder = "2";
    }
    if (this.deputy.parliamentaryGroups[0].position === "Secretario" || this.deputy.parliamentaryGroups[0].position === "Secretaria") {
      this.deputy.groupOrder = "3";
    }
    if (this.deputy.parliamentaryGroups[0].position === "Tesorero" || this.deputy.parliamentaryGroups[0].position === "Tesorera") {
      this.deputy.groupOrder = "4";
    }
    if (this.deputy.parliamentaryGroups[0].position === "Vocal") {
      this.deputy.groupOrder = "5";
    }
    if (this.deputy.parliamentaryGroups[0].position === "Integrante") {
      this.deputy.groupOrder = "6";
    }
    console.log(this.deputy);
    this._deputyService.updateDeputy(this.deputy).subscribe(
      response => {
        if (!response.deputy) {
          this.status = 'error';
        } else {
          this.listarDiputados();
          this.clearDeputy();
          confirm("Registro actualizado exitosamente");
          window.location.reload();
        }
        this.isUpdating = false;
      },
      err => this.onError(err)
    )
  }

  sortArray(array: any[]): any[] {
    return array.sort((a, b) => (a.name.toString()).localeCompare(b.name.toString()));
  }

  searchDeputy(): void {
    console.log(this.nombreBuscar);
    this._deputyService.searchDeputy(this.nombreBuscar).subscribe(
      response => {
        if (response) {
          this.status = 'ok';
          this.deputies = response;
        }
      },
      error => {
        console.log(this.nombreBuscar)
        var errorMessage = error;
        if (errorMessage != null) {
          this.status = 'error'
        }
      }
    );
  }
}
